import { createClientResponse } from '../../utils/pollard'

export default () => {
  return createClientResponse(() => {
    return window.location.href
  })
}
